var map = {
	"./lucky-tnc-cn.svg": 2379,
	"./term-condition-bm.svg": 2380,
	"./term-condition-cn.svg": 2381,
	"./term-condition-id.svg": 2382,
	"./term-condition.svg": 2383,
	"./term-footer-m.jpg": 2384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 132;